// extracted by mini-css-extract-plugin
export var text = "_bv-0";